import { z } from 'zod/v3';
import { DatasetModel } from '../model/dataset.model';
import { ok } from 'neverthrow';
import { Assert } from '@cotera/utilities';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../../actions/framework';
import { DATASET_ACTION_GROUP } from './constants';
import { iconForGraphColumn } from '../../data-grid/utils';

type Params = {
  name: string;
};

export class OpenEditColumnAction extends BaseAction<Params> {
  title = 'Edit Column';
  description = 'Edit a column';
  inputSchema = z.object({
    name: z.string(),
  });
  group = DATASET_ACTION_GROUP;
  icon = 'pencil';

  constructor(
    private navigator: {
      push: (props: {
        title: string;
        route: string;
        displayTitle?: string;
        icon?: string;
      }) => void;
    }
  ) {
    super();
  }

  applicable(context: ApplicableContext): boolean {
    return context.hasTargetedModelOfType(DatasetModel);
  }

  async execute(
    params: Params,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    const dataset = context.targetedModelOfType(DatasetModel);

    Assert.assert(dataset !== null, 'Dataset model not found');

    const datasetName = dataset.currentNameInGraph.snapshot();
    if (!datasetName) {
      throw new Error('Dataset name is null');
    }

    // Get the proper column icon using the same logic as sidebar navigation
    const columnIcon = iconForGraphColumn(dataset.graph.snapshot(), {
      rel: datasetName,
      name: params.name,
    });

    this.navigator.push({
      title: `${datasetName}/${params.name}`,
      displayTitle: params.name,
      icon: columnIcon,
      route: `/dataset/${encodeURIComponent(datasetName)}/column/${
        params.name
      }`,
    });

    return ok({});
  }
}
